import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { PermanentQrEditPage } from "./permanent-qr-edit";
import { ComponentsModule } from "../../../components/components.module";

@NgModule({
  declarations: [
    PermanentQrEditPage
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(PermanentQrEditPage)
  ]
})
export class PermanentQrEditPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/permanent-qr/permanent-qr-edit/permanent-qr-edit.module.ts